 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import LOVE_1 from '@/components/love_1'
 import EBOOK_V4557 from '@/components/eBook_V4557'
 import EBOOK_V45571 from '@/components/eBook_V45571'
 import EBOOK_V45572 from '@/components/eBook_V45572'
 import EBOOK_V45573 from '@/components/eBook_V45573'
 import EBOOK_V45574 from '@/components/eBook_V45574'
 import EBOOK_V45575 from '@/components/eBook_V45575'
 import EBOOK_V45576 from '@/components/eBook_V45576'
 import EBOOK_V45577 from '@/components/eBook_V45577'
 import EBOOK_V45578 from '@/components/eBook_V45578'
 import EBOOK_V45579 from '@/components/eBook_V45579'
 import EBOOK_V455710 from '@/components/eBook_V455710'
 import EBOOK_V455711 from '@/components/eBook_V455711'
 import EBOOK_V455712 from '@/components/eBook_V455712'
 import EBOOK_V455713 from '@/components/eBook_V455713'
 import EBOOK_V455714 from '@/components/eBook_V455714'
 import EBOOK_V455715 from '@/components/eBook_V455715'
 import EBOOK_V455716 from '@/components/eBook_V455716'
 import EBOOK_V455717 from '@/components/eBook_V455717'
 import EBOOK_V455718 from '@/components/eBook_V455718'
 import EBOOK_V455719 from '@/components/eBook_V455719'
 import EBOOK_V455720 from '@/components/eBook_V455720'
 import EBOOK_V455721 from '@/components/eBook_V455721'
 import EBOOK_V455722 from '@/components/eBook_V455722'
 import EBOOK_V455723 from '@/components/eBook_V455723'
 import EBOOK_V455724 from '@/components/eBook_V455724'
 import EBOOK_V455725 from '@/components/eBook_V455725'
 import EBOOK_V455726 from '@/components/eBook_V455726'
 import EBOOK_V455727 from '@/components/eBook_V455727'
 import EBOOK_V455728 from '@/components/eBook_V455728'
 import EBOOK_V455729 from '@/components/eBook_V455729'
 import EBOOK_V455730 from '@/components/eBook_V455730'
 import EBOOK_V455731 from '@/components/eBook_V455731'
 import EBOOK_V455732 from '@/components/eBook_V455732'
 import EBOOK_V455733 from '@/components/eBook_V455733'
 import EBOOK_V455734 from '@/components/eBook_V455734'
 import EBOOK_V455735 from '@/components/eBook_V455735'
 import EBOOK_V455736 from '@/components/eBook_V455736'
 import EBOOK_V455737 from '@/components/eBook_V455737'
 import EBOOK_V455738 from '@/components/eBook_V455738'
 import EBOOK_V455739 from '@/components/eBook_V455739'
 import EBOOK_V455740 from '@/components/eBook_V455740'
 import EBOOK_V455741 from '@/components/eBook_V455741'
 import EBOOK_V455742 from '@/components/eBook_V455742'
 import EBOOK_V455743 from '@/components/eBook_V455743'
 import EBOOK_V455744 from '@/components/eBook_V455744'
 import EBOOK_V455745 from '@/components/eBook_V455745'
 import EBOOK_V455746 from '@/components/eBook_V455746'
 import EBOOK_V455747 from '@/components/eBook_V455747'
 import EBOOK_V455748 from '@/components/eBook_V455748'
 import EBOOK_V455749 from '@/components/eBook_V455749'
 import EBOOK_V455750 from '@/components/eBook_V455750'
 import EBOOK_V455751 from '@/components/eBook_V455751'
 import EBOOK_V455752 from '@/components/eBook_V455752'
 import EBOOK_V455753 from '@/components/eBook_V455753'
 import EBOOK_V455754 from '@/components/eBook_V455754'
 import EBOOK_V455755 from '@/components/eBook_V455755'
 import EBOOK_V455756 from '@/components/eBook_V455756'
 import EBOOK_V455757 from '@/components/eBook_V455757'
 import EBOOK_V455758 from '@/components/eBook_V455758'
 import EBOOK_V455759 from '@/components/eBook_V455759'
 import EBOOK_V455760 from '@/components/eBook_V455760'
 import EBOOK_V455761 from '@/components/eBook_V455761'
 import EBOOK_V455762 from '@/components/eBook_V455762'
 import EBOOK_V455763 from '@/components/eBook_V455763'
 import EBOOK_V455764 from '@/components/eBook_V455764'
 import EBOOK_V455765 from '@/components/eBook_V455765'
 import EBOOK_V455766 from '@/components/eBook_V455766'
 import EBOOK_V455767 from '@/components/eBook_V455767'
 import EBOOK_V455768 from '@/components/eBook_V455768'
 import EBOOK_V455769 from '@/components/eBook_V455769'
 import EBOOK_V455770 from '@/components/eBook_V455770'
 import EBOOK_V455771 from '@/components/eBook_V455771'
 import EBOOK_V455772 from '@/components/eBook_V455772'
 import EBOOK_V455773 from '@/components/eBook_V455773'
 import EBOOK_V455774 from '@/components/eBook_V455774'
 import EBOOK_V455775 from '@/components/eBook_V455775'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/eBook_V4557",
 			"name" : "eBook_V4557",
 			"component" : EBOOK_V4557
 		},
 		{
 			"path" : "/eBook_V45571",
 			"name" : "eBook_V45571",
 			"component" : EBOOK_V45571
 		},
 		{
 			"path" : "/eBook_V45572",
 			"name" : "eBook_V45572",
 			"component" : EBOOK_V45572
 		},
 		{
 			"path" : "/eBook_V45573",
 			"name" : "eBook_V45573",
 			"component" : EBOOK_V45573
 		},
 		{
 			"path" : "/eBook_V45574",
 			"name" : "eBook_V45574",
 			"component" : EBOOK_V45574
 		},
 		{
 			"path" : "/eBook_V45575",
 			"name" : "eBook_V45575",
 			"component" : EBOOK_V45575
 		},
 		{
 			"path" : "/eBook_V45576",
 			"name" : "eBook_V45576",
 			"component" : EBOOK_V45576
 		},
 		{
 			"path" : "/eBook_V45577",
 			"name" : "eBook_V45577",
 			"component" : EBOOK_V45577
 		},
 		{
 			"path" : "/eBook_V45578",
 			"name" : "eBook_V45578",
 			"component" : EBOOK_V45578
 		},
 		{
 			"path" : "/eBook_V45579",
 			"name" : "eBook_V45579",
 			"component" : EBOOK_V45579
 		},
 		{
 			"path" : "/eBook_V455710",
 			"name" : "eBook_V455710",
 			"component" : EBOOK_V455710
 		},
 		{
 			"path" : "/eBook_V455711",
 			"name" : "eBook_V455711",
 			"component" : EBOOK_V455711
 		},
 		{
 			"path" : "/eBook_V455712",
 			"name" : "eBook_V455712",
 			"component" : EBOOK_V455712
 		},
 		{
 			"path" : "/eBook_V455713",
 			"name" : "eBook_V455713",
 			"component" : EBOOK_V455713
 		},
 		{
 			"path" : "/eBook_V455714",
 			"name" : "eBook_V455714",
 			"component" : EBOOK_V455714
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js